const imgUrl = {
  smileLogo: require("./homeimages/smile-logo-old.png"),
  drhuzaifa:require("./homeimages/Dr-Huzaifa.png"),
  globalmap:require("./homeimages/globalmap.png"),
  birdLeftside:require("./homeimages/bird-left.png"),
  wockhardtLogo:require("./homeimages/wockhardtLogo.png"),
  globalJusticeLogo:require("./homeimages/globaljusticeLogo.png"),
  lifewinsLogo:require("./homeimages/LifeWinslogo.png"),
  peacekeeperLogo:require("./homeimages/peackeeperLogo.png"),
  nobelLogo:require("./homeimages/nobelLogo.png"),
  jupiterLogo:require("./homeimages/JupiterLogo.png"),
  guineaBissauLogo:require("./homeimages/Coat_of_arms_of_Guinea-Bissau.png"),
  shape:require("./homeimages/shape-bg.png"),
  lifeStory:require("./biographyimages/lifestory.png"),
  careerMilestone:require("./biographyimages/careermilestone.png"),
  timeline:require("./biographyimages/timeline.png"),
  insights:require("./biographyimages/insights.png"),
  peace:require("./biographyimages/peace.png"),
  trophy:require("./awardsimages/trophy.png"),
  goldenAward:require("./awardsimages/goldenAward.png"),
  award:require("./awardsimages/award.png"),
  dlitt:require("./awardsimages/dlitt.png"),
  professorship:require("./awardsimages/professorship.png"),
  knighthood:require("./awardsimages/knighthood.png"),
  princehood:require("./awardsimages/princehood.png"),
  manOftheYear:require("./awardsimages/manoftheyear.png"),
  doctrate:require("./awardsimages/doctrate.png"),
  bgGradient:require("./biographyimages/bgGradient.png"),
  initiativeGradient:require("./biographyimages/initiativesGradient.png"),
  peacekeeperBg:require("./biographyimages/peacekeepBG.png"),
  leadership:require("./leadershipimages/leadership.png"),
  publication:require("./leadershipimages/publication.png"),
  article:require("./leadershipimages/article.png"),
  interview:require("./leadershipimages/interview.png"),
  television:require("./leadershipimages/television.png"),
  panel:require("./leadershipimages/panel.png"),
  print:require("./leadershipimages/print.png"),
  podcast:require("./leadershipimages/podcast.png"),
  keynote:require("./leadershipimages/keynote.png"),
  bgGradienttwo:require("./leadershipimages/bgGradient.png"),
  convocation:require("./leadershipimages/convocation.png"),
  corporate:require("./leadershipimages/corporate.png"),
  gallery:require("./mediaimages/gallery.png"),
  galleryCarousel:require("./mediaimages/galleryCarousel.png"),
  video:require("./mediaimages/video.png"),
  mediakit:require("./mediaimages/mediakit.png"),
  hd:require("./mediaimages/hd.png"),
  profile:require("./mediaimages/profile.png"),
  document:require("./mediaimages/document.png"),
  biography:require("./mediaimages/biography.png"),
  announcement:require("./eventsimages/announcement.png"),
  summit:require("./eventsimages/summit.png"),
  foundation:require("./eventsimages/foundation.png"),
  engagement:require("./eventsimages/engagement.png"),
  facebook:require("./contactimages/facebook.png"),
  instagram:require("./contactimages/instagram.png"),
  linkedin:require("./contactimages/linkedin.png"),
  youtube:require("./contactimages/youtube.png"),
  conversation:require("./contactimages/conversation.png"),
  connect:require("./contactimages/connect.png"),
  justiceBG:require("./biographyimages/justiceBG.png"),
  billionaireBG:require("./biographyimages/billionaireBG.png"),
  birdRightside:require("./biographyimages/bird-right.png"),
  mobile1000:require("./biographyimages/mobile_1000.png"),
  gurLogo:require("./biographyimages/gur.png"),
  khelLogo:require("./biographyimages/khel.png"),
  hungerLogo:require("./biographyimages/hunger_project.png"),
  pronto:require("./biographyimages/pronto.png"),
  e_learning:require("./biographyimages/e_learning.png"),
  tapIcon:require('./contactimages/tap.png'),
  tapIconwhite:require('./awardsimages/tap-white.png'),

  //gallery images

  galleryImgone:require("./mediaimages/gallery/Dr. Bhagwat Karad, Union Minister of State for Finance (16-April-2022).jpeg"),
  galleryImgtwo:require("./mediaimages/gallery/Former Maharashtra Governor, Shri Bhagat Singh Koshyari (06-April-2022).jpg"),
  galleryImgthree:require("./mediaimages/gallery/Madhusudan Agrawal, Co-Founder & Vice Chairman, Ajanta Pharma (April-2022).jpeg"),
  galleryImgfour:require("./mediaimages/gallery/Adil Allana (left), Owner, Allanasons (August-2022).jpeg"),
  galleryImgfive:require("./mediaimages/gallery/Jackbastian Nazareth (left), CEO, Adani Realty (August-2022).jpeg"),
  galleryImgsix:require("./mediaimages/gallery/Mr. Fareed Zakaria (left), CNN Journalist (December-2022).jpg"),
  galleryImgseven:require("./mediaimages/gallery/Padma Shri Madhu Pandit Dasa (left), Founder Chairman Akshay Patra Foundation (December-2022).jpg"),
  galleryImgeight:require("./mediaimages/gallery/Shri Suresh Khade (right), Labour Minister, Maharashtra (06-April-2023).jpg"),
  galleryImgnine:require("./mediaimages/gallery/Capt B K Tyagi (right), Chairman & Managing Director, Shipping Corporation of India (May-2023).jpg"),
  galleryImgten:require("./mediaimages/gallery/Dr. Suresh Chandra Padhye (left), Vice Chancellor, Poornima University @ Jaipur (23-September-2023).jpg"),
  galleryImgeleven:require("./mediaimages/gallery/Yaqoob Al Ali (left), ED & Private Advisor to the Office of His Highness Sheikh Juma bin Maktoum Al Maktoum (September-2024).jpg"),
  galleryImgtwelve:require("./mediaimages/gallery/Anu Malik, Music Composer, 11 Feb 2022.jpeg"),
  galleryImgthirteen:require("./mediaimages/gallery/Ashish Shelar, ex-Education Minister, Maharashtra 7 Feb 2022.jpeg"),
  galleryImgfourteen:require("./mediaimages/gallery/Asif Bhamla,Close Friend Chairman Bhamla Foundation @ his 20th wedding anniversary 11 Feb 2022.jpeg"),
  galleryImgfifteen:require("./mediaimages/gallery/Baba Ramdev, Indian Yoga Guru & Ayurvedic Champion 9 Feb 2022.jpeg"),
  galleryImgsixteen:require("./mediaimages/gallery/Dr Ramdas Bandu Athawale, Minister of State for Social Justice & Empowerment 13-Feb-2022.jpeg"),
  galleryImgseventeen:require("./mediaimages/gallery/Dr. Varun Choudhury Close Friend & Director, CG Corp Global 7 Feb 2022.jpeg"),
  galleryImgeighteen:require("./mediaimages/gallery/Late Raju Srivastav, Comedian, 11 Feb 2022.jpeg"),
  galleryImgnineteen:require("./mediaimages/gallery/Majeed Menon, Rajya Sabha MP, & Advocate of Supreme Court of India, 11 Feb 2022.jpeg"),
  galleryImgtwenty:require("./mediaimages/gallery/Mohit Kamboj, BJP Leader 7 Feb 2022.jpeg"),
  galleryImgtwentyone:require("./mediaimages/gallery/Nitin Raut, Minister of Energy, Maharashtra Government 17 Feb 2022.jpeg"),
  galleryImgtwentytwo:require("./mediaimages/gallery/Paramjit Dahia, Deputy Commisioner of Police, Worli 12 Feb 2022.jpeg"),
  galleryImgtwentythree:require("./mediaimages/gallery/Poonam Mahajan, Lok Sabha MP 11 Feb 2022.jpeg"),
  galleryImgtwentyfour:require("./mediaimages/gallery/Rakeysh Omprakash Mehra, Indian Film Director 20 Feb 2022.jpeg"),
  galleryImgtwentyfive:require("./mediaimages/gallery/Richard Prattle, Co-Founder & CEO, True Beacon 24 Feb 2022.jpeg"),
  galleryImgtwentysix:require("./mediaimages/gallery/Shahida Parveen ACP (killed 80 terrorists) 11 Feb 2022.jpeg"),
  galleryImgtwentyseven:require("./mediaimages/gallery/Shashi Kumar Meena, Deputy Commisioner of Police 12 Feb 2022.jpeg"),
  galleryImgtwentyeight:require("./mediaimages/gallery/Zayed Khan, Close Friend, & Actor 28 Feb 2022.jpeg")
};



export default imgUrl;